<template>
  <div data-module="partners">
    <component_bigHeading :data="{heading: 'Our<br/>Partners.', byline: 'We partner with global brands and wiley start-ups across industries. Take a look at a selection of the people that make us love what we do.'}" />
    <div class="partners__grid">
        <div v-for="client in data.clients" :key="client.name" class="client">
          <a :href="client.href" v-if="client.href">
            <template v-if="client.logo">
              <img :src="client.logo" :alt="client.name" />
            </template>
            <template v-else>
              <span>{{client.name}}</span>
            </template>
          </a>
          <template v-else>
            <template v-if="client.logo">
              <img :src="client.logo" :alt="client.name" />
            </template>
            <template v-else>
              <span>{{client.name}}</span>
            </template>
            </template>
        </div>
        <div class="client spanner"></div>
        <div class="client spanner"></div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'module_partners',
  props: ['data'],
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="partners"] {
  @include spacer();
  @include grid($rows: 2, $subgrid: true);

  [data-component="bigHeading"] {
    grid-row: 1 / span 1;
    grid-column: 6 / span 7;
    text-align: right;
    margin-bottom: rem(43px);

    [data-ornament] {
      margin-left: auto;

      @include mq($bp--tablet, up) {
        left: auto;
        right: 0;
      }
    }
  }

  .partners__grid {
    grid-row: 2 / span 1;
    grid-column: 1 / span 12;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;

    .client {
      width: 30%;
      text-align: center;
      margin-bottom: rem(75px);
      padding: 0 1rem;

      @include mq(1024px, down) {
        width: 50%;
        margin-bottom: rem(75px);
      }

      img {
        max-width: 100%;
        max-height: 100px;
        display: block;
        margin: 0 auto;
      }

      &.spanner {
        margin: 0;
      }

      > a {
        display: inline-block;
        margin: auto;
      }
    }
  }

  @include mq(1024px, down) {
    [data-component="bigHeading"] {
      grid-column: 1 / span 12;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/modules/partners.vue